import type { ClockMatchState } from '@/types/sports/clock';

export const isInterval = (matchState: ClockMatchState): boolean =>
  matchState === 'break' || matchState === 'timeout';

export const breakLabel = (periodLabel: string): string =>
  periodLabel === 'Half' ? 'Half time' : 'Break';

export const intervalLabel = (
  matchState: ClockMatchState,
  periodLabel: string,
): string => (matchState === 'timeout' ? 'Timeout' : breakLabel(periodLabel));
